import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import createProps from './createProps';

const modificatorKeys = [
  'start',
  'center',
  'end',
  'top',
  'middle',
  'bottom',
  'around',
  'between',
  'first',
  'last',
];

const getClassNames = (props) => {
  const modificators = ['row'];

  modificatorKeys.forEach((key) => {
    const value = props[key];
    if (value) {
      modificators.push(`${key}-${value}`);
    }
  });

  if (props.reverse) {
    modificators.push('reverse');
  }

  return classNames(props.className, modificators);
};

const Row = (props) =>
  React.createElement(props.tagName || 'div', createProps(props, getClassNames(props)));

export default Row;

Row.propTypes = {
  start: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  center: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  end: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  top: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  middle: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  bottom: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  around: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  between: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  first: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  last: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  reverse: PropTypes.bool,
  className: PropTypes.string,
  tagName: PropTypes.string,
  children: PropTypes.node,
};
